import Gikam from '../core/gikam-core.js';
import FormPanel from './template/form.vue';
import Vue from 'vue';
import Base from "./base";
import Mask from './template/mask/mask.vue';
import jQuery from 'jquery';


let defaultOptions = {
    renderTo: void 0,
    columns: 2,
    fields: [],
    panels: [],
    data: {
        ext$: {}
    },
    titleWidthAuto: false,
    titleAlign: void 0,
    service: void 0,
    autoSave: true
};

export default class Form extends Base {

    constructor(options) {
        super();
        this.validators = {};
        this.canAutoSave = true;
        this.triggerChangeFlag = true;
        this.listeners = {
            loadSuccess: Gikam.emptyFunction,
            afterChoose: Gikam.emptyFunction,
            rendered: Gikam.emptyFunction,
            inserted: Gikam.emptyFunction,
            updated: Gikam.emptyFunction,
            beforeUpdate: (data, keys) => [data, keys]
        };
        this.initialize(options, defaultOptions).init();
    }

    createModel() {
        let _this = this;
        let mountedDom = document.createElement('dom');
        this.options.renderTo.appendChild(mountedDom);
        this.options.parent = this;
        this.cacheSelectItems(this.options.panels).done(() => {
            this.model = new Vue({
                el: mountedDom,
                components: { FormPanel },
                provide: {
                    form: _this
                },
                data() {
                    return {
                        options: _this.options
                    }
                },
                render() {
                    return <form-panel ref="vm" options={this.options}></form-panel>;
                }
            });
            this.model.$nextTick(() => {
                this.bindInstance(_this.model.$el);
                this.refresh(null, false);
                this.trigger('rendered');
            });
        });
    }

    notify() {
        const pro = Gikam.createdComponent[this.options.id];
        if (pro) {
            pro.resolve(this);
            delete Gikam.createdComponent[this.options.id];
        }
    }

    getData() {
        const data = Gikam.deepExtend(this.options.data);
        const keys = Object.getOwnPropertyNames(data);
        if (keys.length === 1 && keys[0] === 'ext$') {
            return this.model.$refs.vm.getData();
        }
        return data;
    }

    setData(data, saveFlag = true) {
        this.canAutoSave = false;
        this.options.data = Gikam.deepExtend(this.options.data, data, { id: this.getData().id });
        const _this = this;
        this.model.$nextTick(() => {
            _this.canAutoSave = true;
            saveFlag && this.autoSave(data);
        });
    }

    cacheSelectItems(panels) {
        let filterType = ['Select', 'SelectInput', 'ComboBox'];
        let codeArray = [];
        panels.forEach(panel => {
            panel.fields.forEach(function (item) {
                if (filterType.indexOf(Gikam.toInitialUpperCase(item.type || '')) > -1 && Gikam.isEmpty(item.items)) {
                    codeArray.push(item);
                }
            });
        });
        if (Gikam.isEmpty(codeArray)) {
            return jQuery.Deferred().resolve();
        }
        return Gikam.select.cacheItems(codeArray);
    }

    openMask() {
        if (this.maskModel) {
            return;
        }
        this.maskModel = new Vue({
            el: Gikam.createDom('div', document.body),
            components: { Mask },
            render() {
                return <Mask />;
            }
        });
    }

    closeMask() {
        this.maskModel.$nextTick(() => {
            this.maskModel.$destroy();
            Gikam.removeDom(this.maskModel.$el);
            this.maskModel = null;
        });
    }

    refresh(param, cleanFlag) {
        this.openMask();
        cleanFlag !== false && this.cleanData();
        let _this = this, def = jQuery.Deferred();
        param && this.setOptions(param);
        this.options.url && Gikam.getJson(this.options.url).done(function (data) {
            _this.toFieldsReadonly(['id']);
            _this.loadData(data);
            def.resolve(data);
        }).fail(function () {
            def.reject();
        }).always(function () {
            _this.closeMask();
        });
        if (!this.options.url) {
            this.closeMask();
        }
        return def;
    }

    /**
     * @description 动态刷新表单中的字段
     * @public
     * @param {Array} param 再次刷新的字段，例如表单分组参数[{title:'',fields:[{field:''}]}]，普通表单：[{field:''}]
     * @returns
     * @memberof Form
     */
    refreshFields(param) {
        if (!Array.isArray(param)) {
            return;
        }
        let panels = param[0].fields ? param : [{ fields: param }];
        this.cacheSelectItems(panels).done(() => {
            this.options.panels = panels;
            this.validators = {};
            this.registerValidators();
        })
    }

    loadData(data) {
        this.triggerChangeFlag = false;
        this.canAutoSave = false;
        this.options.data = Gikam.deepExtend(this.options.data, data);
        const _this = this;
        this.model.$nextTick(() => {
            _this.canAutoSave = true;
            this.triggerChangeFlag = true;
        });
        this.trigger('loadSuccess', Gikam.deepExtend(this.options.data));
    }

    setOptions(param) {
        jQuery.extend(true, this.options, param);
    }

    getOptions() {
        return Gikam.deepExtend(this.options);
    }

    showValidateMessage(error) {
        let tpl = '<div class="validator-error-container">' +
            '<span class="error-title">' + Gikam.propI18N('GIKAM.TIP.INVALID_INPUT_FIELDS') + '</span>' +
            '<div class="error-zone">{errorMessage}</div>' +
            '</div>';
        let errorMessage = '';
        error.forEach(function (item) {
            errorMessage += '<div>' + '<span class="error-field-desc">' + Gikam.propI18N(item.title) + '</span>' + Gikam.propI18N(item.message) + '</div>'
        });

        Gikam.alert(Gikam.printf(tpl, {
            errorMessage: errorMessage,
        }), 200);
    }

    /**
     * @description 注册panels内所有的验证条件
     * @private
     * @memberof Form
     */
    registerValidators() {
        const panelsFields = this.getPanelsFields();
        if (Gikam.isEmpty(panelsFields)) {
            return
        }
        panelsFields.filter((item) => Gikam.isNotEmpty(item.validators))
            .forEach((item) => {
                this.baseAddFieldVal(item);
            });
        return this;
    }

    validate() {
        let _this = this;
        let error = [];
        const values = {};
        this.model.$refs.vm.$children.forEach(item => {
            values[item.field] = item.value;
        })
        let data = Gikam.extend(this.getData(), values);
        Gikam.each(this.validators, function (field) {
            let fieldValidateResult = true;
            Gikam.each(this, function () {
                let r = Gikam.validator[this.type](Gikam.getFieldValue(data, field), this.rule, field, data.id);
                if (r.result === false) {
                    error.push({
                        field: field,
                        title: this.title,
                        message: r.message
                    });
                    fieldValidateResult = false;
                    return false;
                }
            });
            _this.model.$children[0].$refs[field].validateResult = fieldValidateResult;
        });

        if (Gikam.isEmpty(error)) {
            return true;
        } else {
            this.showValidateMessage(error);
            return false;
        }
    }

    toFieldsReadonly(array) {
        if (!Array.isArray(array)) {
            array = [array];
        }
        this.setFieldsReadonly(array, true);
    }

    toFieldsEdit(array) {
        if (!Array.isArray(array)) {
            array = [array];
        }
        this.setFieldsReadonly(array, false);
    }

    setFieldsReadonly(array, isReadonly) {
        let _this = this;
        array.forEach((item) => {
            let field = _this.model.$children[0].$refs[item];
            if (field) {
                field.readonly = isReadonly
            }
        });
    }

    removeFieldValidator(field, validators) {
        Gikam.each(this.validators, function (key, value) {
            if (key === field) {
                for (let i = value.length - 1; i > -1; i--) {
                    validators.indexOf(value[i].type) > -1 && value.splice(i, 1);
                }
                return false;
            }
        });
        return this;
    }

    /**
     * @description 增加验证内容
     * @public
     * @param {string} field 需要增加验证的fields字段
     * @param {array} validators 需要增加验证内容
     * @memberof Form
     */
    addFieldValidator(field, validators) {
        const currentFields = this.getPanelsFields().filter(item => item.field === field)[0]
        currentFields.validators = validators;
        this.baseAddFieldVal(currentFields);
        return this;
    }

    /**
     * @description 获取所有panels下的fields
     * @private
     * @memberof Form
     */
    getPanelsFields() {
        return this.options.panels.reduce(function (total, item) {
            return total.concat(item.fields);
        }, []);
    }

    /**
     * @description 将fileds字段内的验证内容 固定到 this.validators 对象中
     * @private
     * @param {object} fieldItem 需要增加验证的fileds字段
     * @memberof Form
     */
    baseAddFieldVal(item) {
        this.validators[item.field] = [];
        item.validators.forEach((name) => {
            let newValidator = null;
            if (name.indexOf('strLength') === 0) {
                newValidator = {
                    type: 'strLength',
                    rule: name.replace('strLength', '')
                }
            } else if (name.indexOf('numRange') === 0) {
                newValidator = {
                    type: 'numRange',
                    rule: name.replace('numRange', '')
                }
            } else if (name.indexOf('remote') === 0) {
                newValidator = {
                    type: 'remote',
                    rule: name.replace(/remote|\[|]/g, '')
                }
            } else {
                newValidator = {
                    type: name,
                }
            }
            const validator = Gikam.extend({}, newValidator);
            validator.title = item.title;
            this.validators[item.field].push(validator);
        });
    }

    setSelectOptions(field, list) {
        this.model.$children[0].$refs[field].items = list;
    }

    getField(field) {
        return this.model.$children[0].$refs[field];
    }

    /* 
    私有方法
    自动保存时使用，用于获取字段的type和items
     */
    getFieldInfoByData(data) {
        const fieldInfo = {};
        this.options.panels.forEach(panel => {
            panel.fields.forEach(fieldOptions => {
                if (Gikam.isNotEmpty(data[fieldOptions.field], true) && ['select', 'simpleCheckbox'].indexOf(fieldOptions.type) > -1) {
                    const options = {
                        type: fieldOptions.type === 'simpleCheckbox' ? 'checkbox' : (fieldOptions.type || 'text'),
                    };
                    if (fieldOptions.type === 'select') {
                        options.items = fieldOptions.items;
                    }
                    fieldInfo[fieldOptions.field] = options;
                }
            });
        });
        return fieldInfo;
    }

    autoSave(data) {
        if (!this.options.autoSave) {
            return;
        }
        if (this.trigger('beforeUpdate', data, Object.keys(data)) === false) {
            return;
        }
        const update = () => {
            let _this = this;
            Gikam.put(Gikam.IFM_CONTEXT + '/secure/gikam/actions/instant', Gikam.getJsonWrapper({ t: this.getFieldInfoByData(data) }, [this.options.service, [data]])).done(() => {
                _this.trigger('updated', data);
            });
        }
        if (Gikam.isNotEmpty(this.getData().id)) {
            if (Gikam.isEmpty(data.id)) {
                data.id = this.getData().id;
            }
            update();
        } else {
            if (this.options.insertUrl) {
                const _this = this;
                Gikam.post(this.options.insertUrl).done((id) => {
                    _this.trigger('inserted', id);
                    _this.setData({ id: id }, false);
                    data.id = id;
                    update();
                });
            } else {
                Gikam.error(`can not find insertUrl in ${this.options.id}`);
            }
        }
    }

    enableAutoSave() {
        this.canAutoSave = true;
    }

    disableAutoSave() {
        this.canAutoSave = false;
    }

    initReadonly() {
        if (this.options.readonly === true) {
            this.options.panels.forEach(panel => {
                panel.fields.forEach(item => {
                    item.readonly = true;
                });
            })
        }
    }

    /**
     * @description 整合fields 到panels内
     * @private
     * @memberof Form
     */
    initPanelFields() {
        if (Gikam.isEmpty(this.options.panels)) {
            this.options.panels.push({ fields: this.options.fields });
        }
    }

    toggleFields(fields, action) {
        if (!Array.isArray(fields)) {
            Gikam.error(`${action}Fields function param require Array`);
            return;
        }
        const _this = this;
        const viewModel = _this.model.$refs.vm;
        fields.forEach(field => {
            viewModel.$refs['group_' + field][0].style.display = action === 'show' ? '' : 'none';
        });
    }

    showFields(fields) {
        this.toggleFields(fields, 'show');
    }

    hideFields(fields) {
        this.toggleFields(fields, 'hide');
    }

    cleanData() {
        this.disableAutoSave();
        this.options.data = { ext$: {} };
        this.model.$nextTick(() => {
            this.enableAutoSave();
        });
    }

    /**
     * @description 将字段中设置的value值添加到data中
     * @private
     * @memberof Form
     */
    initData() {
        if (Gikam.isNotEmpty(this.options.panels)) {
            this.options.panels.forEach(panel => {
                panel.fields.forEach(field => {
                    if (Gikam.isNotEmpty(field.value)) {
                        Gikam.setFieldValue(this.options.data, field.field, field.value);
                    }
                });
            })
        }
    }

    init() {
        this.initPanelFields();
        this.registerValidators();
        this.initData();
        this.initReadonly();
        this.createModel();
    }
}
